import { POST } from '@/api'
import { omit, isEmpty } from 'lodash'
import { renameKeysToSnakeCase } from '@/utils/renameKeys'
import { getSmokingCodeByStr } from '@/resources/customer/smokingMap'
import { getGenderCodeByStr } from '@/resources/customer/genderMap'
import { getAttributesCodeListByStr } from '@/resources/customer/attributesMap'

const CUSTOMER_DEFAULT = {
  id: null,
  photo: [],
  syncMemberType: null,
  lastNameKana: null,
  firstNameKana: null,
  lastName: null,
  firstName: null,
  tel1: null,
  tel1DuplicationFlag: false,
  tel2: null,
  tel2DuplicationFlag: false,
  mail1: null,
  mail2: null,
  officeName: null,
  department: null,
  post: null,
  officeZipCode: null,
  officeAddress: null,
  officeTel: null,
  receiptAddress: null,
  officeRemarks: null,
  zipCode: null,
  address: null,
  attributes: [],
  otherAttributes: [],
  gender: 0,
  birthday: null,
  wedding: null,
  otherAnniversaries: [],
  smoking: 0,
  allergies: null,
  favoriteFood: null,
  notFavoriteFood: null,
  customerRemarks: null,
  twitter: null,
  facebook: null,
  directMail: 0,
  remarks: null,
  options: {},
  customerRelations: [],
  deleteImageIds: [],
}

export default {
  namespaced: true,
  state: {
    origin: { ...CUSTOMER_DEFAULT },
    customer: { ...CUSTOMER_DEFAULT },
    busy: false,
  },
  mutations: {
    clear(state) {
      state.origin = { ...CUSTOMER_DEFAULT }
      state.customer = { ...CUSTOMER_DEFAULT }
    },
    set(state, detail) {
      state.origin = { ...detail }
      state.customer = { ...detail }
    },
    update(state, detail) {
      state.customer = { ...state.customer, ...detail, options: { ...state.customer.options, ...detail.options } }
    },
    reset(state) {
      state.customer = { ...state.origin }
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async get(store, id) {
      const { commit } = store

      commit('busy', true)

      const { status, message, data } = await POST('/api/web/customer/detail', { id })
      if (status === 200) {
        const { name, company, options, ...customer } = data.customer
        commit('set', {
          ...CUSTOMER_DEFAULT,
          ...omit(customer, ['attributesList']),
          lastNameKana: name.lastKana,
          firstNameKana: name.firstKana,
          lastName: name.last,
          firstName: name.first,
          officeName: company.name,
          department: company.department,
          post: company.post,
          officeZipCode: company.zipCode,
          officeAddress: company.address,
          officeTel: company.tel,
          receiptAddress: company.receiptAddress,
          officeRemarks: company.remarks,
          attributes: getAttributesCodeListByStr(customer.attributes),
          gender: getGenderCodeByStr(customer.gender),
          smoking: getSmokingCodeByStr(customer.smoking),
          options: options ? options.reduce((o, option) => Object.assign(o, { [option.id]: option.value }), {}) : {},
        })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
    async save(store) {
      const { commit, state } = store

      if (state.busy) return false
      commit('busy', true)

      const { options, ...customer } = state.customer

      const { status, message, data } = await POST(
        '/api/web/customer/regist',
        renameKeysToSnakeCase({
          ...omit(customer, [
            'tel1DuplicationFlag',
            'tel2DuplicationFlag',
            'lastVisitDate',
            'visitCount',
            'visitCountOther',
            'visitHistory',
          ]),
          attributes: customer.attributes.join(','),
          otherAnniversaries: customer.otherAnniversaries.filter(annv => !isEmpty(annv)),
          otherAttributes: customer.otherAttributes.map(attr => attr.id).join(','),
          customerRelations: customer.customerRelations.map(relation => relation.id).join(','),
          deleteImageIds: customer.deleteImageIds,
          options: options ? Object.keys(options).map(id => ({ id: +id, value: options[id] })) : null,
        }),
      )

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200 && data.customer.id
    },

    async delete(store) {
      const {
        commit,
        state: {
          customer: { id },
          busy,
        },
      } = store

      if (busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/customer/delete', { id })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
